import React from 'react';
import { IconProvider } from '../components/Icon/context';
import { InjectGlobalStyle } from './InjectGlobalStyle';
import ThemeProvider from './ThemeProvider';

var Tractor = function Tractor(_ref) {
  var theme = _ref.theme,
      icons = _ref.icons,
      _ref$injectStyle = _ref.injectStyle,
      injectStyle = _ref$injectStyle === void 0 ? false : _ref$injectStyle,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(IconProvider, {
    value: {
      icons: icons
    }
  }, children, injectStyle && /*#__PURE__*/React.createElement(InjectGlobalStyle, null)));
};

export default Tractor;